import { render, staticRenderFns } from "./RoundSelectorDialog.vue?vue&type=template&id=3ef8e514&scoped=true"
import script from "./RoundSelectorDialog.vue?vue&type=script&lang=js"
export * from "./RoundSelectorDialog.vue?vue&type=script&lang=js"
import style0 from "./RoundSelectorDialog.vue?vue&type=style&index=0&id=3ef8e514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef8e514",
  null
  
)

export default component.exports